import { createTheme, type Theme } from '@mui/material/styles';

// North Star type treatment, kept in this one scoped place. The base KareHero
// theme sets h1–h3 in Lora SemiBold Italic; here we render headings in Work Sans
// (the body font), in charcoal. Set on the typography variants themselves (what
// Typography actually reads) so it applies everywhere the variant is used —
// including llama's PageHeader inside the Care detail screens. Sizes/spacing
// come from the base theme; we only swap family, style, weight and colour.
// The "Welcome" greeting stays the deliberate italic exception (welcomeHeadingSx).
const SANS_HEADING = {
  fontFamily: 'Work Sans, sans-serif',
  fontStyle: 'normal' as const,
  fontWeight: 600,
};

export const welcomeHeadingSx = {
  fontFamily: 'Lora, serif',
  fontStyle: 'italic',
  fontWeight: 600,
  color: 'custom.charcoal',
} as const;

export const northStarTheme = (outer: Theme) => {
  const charcoal = (
    outer.palette as unknown as { custom: { charcoal: string } }
  ).custom.charcoal;
  return createTheme(outer, {
    typography: {
      h1: { ...SANS_HEADING, color: charcoal },
      h2: { ...SANS_HEADING, color: charcoal },
      h3: { ...SANS_HEADING, color: charcoal },
      h4: { color: charcoal },
    },
  });
};
